import Head from 'next/head';
import SiteLayout from '@/components/layout/SiteLayout';
import { ProjektDetailSection } from '@/components/sections/ProjektDetailSection';
import { projektMitNachbarn, veroeffentlichteProjektIds } from '@/lib/content/projekte';
import { projektBilder } from '@/lib/images';

export default function ProjektDetail({ data, seo, bilder, nextProjectId, previousProjectId }) {
  return (
    <SiteLayout>
      <Head>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <link rel="canonical" href={seo.canonicalUrl} />
      </Head>
      <ProjektDetailSection
        key={data.projekt_id}
        content={data}
        bilder={bilder}
        nextProjectId={nextProjectId}
        previousProjectId={previousProjectId}
      />
    </SiteLayout>
  );
}

export async function getStaticPaths() {
  const ids = await veroeffentlichteProjektIds();
  return {
    paths: ids.map((id) => ({ params: { id: String(id) } })),
    // Nicht vorgebaute Kennungen werden beim ersten Aufruf serverseitig
    // erzeugt. Das ist NICHT der Weg zu unveroeffentlichten Projekten - die
    // filtert projektMitNachbarn() weg, und getStaticProps macht daraus 404
    // (siehe SICHERHEIT.md, Befund 1). Es haelt aber ein Projekt erreichbar,
    // das im Admin-Bereich gerade freigegeben wurde, ohne neuen Build.
    fallback: 'blocking',
  };
}

export async function getStaticProps({ params }) {
  const projekt = await projektMitNachbarn(params.id);
  if (!projekt) return { notFound: true, revalidate: 300 };

  const seo = {
    title: `Marlene Gujan Architektur AG | ${projekt.titel}`,
    description: projekt.beschreibung
      ? projekt.beschreibung.slice(0, 160)
      : 'Projektdetailansicht',
    keywords: `Projekt, Architektur, ${projekt.titel}, ${projekt.projektart}, Gujan Architektur, Marlene Gujan Architektur AG, Architekt`,
    canonicalUrl: `https://www.gujan-architektur.ch/projekte/${projekt.projekt_id}`,
  };

  return {
    props: {
      data: {
        projekt_id: projekt.projekt_id,
        titel: projekt.titel,
        untertitel: projekt.untertitel,
        beschreibung: projekt.beschreibung,
        bauinfos: projekt.bauinfos,
        projektart: projekt.projektart,
        jahr: projekt.jahr,
      },
      bilder: projektBilder(projekt.projekt_id),
      seo,
      nextProjectId: projekt.nextProjectId,
      previousProjectId: projekt.previousProjectId,
    },
    revalidate: 300,
  };
}
